export default {
  opportunities: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  produtos: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  clients: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // {{NEXT}}
}
